export default {
  customGroupsLoading: false,
  isArchiveAdmin: false,
  customGroupItemsLoading: false,
  isDeletingCustomGroupInProgress: false,
  customGroups: [],
  customGroupItems: {
    CG: [],
    BR: [],
  },
  customGroupItemTypes: {
    CG: [],
    BR: [],
  },
  createdCustomGroup: null,
  selectedCustomGroupId: null,
  selectedGroupItemType: null,
  readOnly: true,
  isCreatingNewCustomGroup: false,
  isCustomGroupModified: false,
  isRefreshingCustomGroups: false,
};
